export const TEMPLE_DATUMS = Object.freeze({
  beamBottom: 18.5,
  shaftBottom: 46.2,
});

export const TEMPLE_COLUMN_CENTERS = Object.freeze({
  outer: Object.freeze([13, 47]),
  inner: Object.freeze([23, 37]),
});

export const TEMPLE_FOUNDATION_RECTS = Object.freeze({
  stylobate: Object.freeze({ x: 9, y: 45.7, width: 42, height: 2.4, rx: 0.35 }),
  lower: Object.freeze({ x: 7, y: 47.9, width: 46, height: 2.4, rx: 0.35 }),
});

export const getTempleShaftTop = pillarTier => (
  pillarTier >= 2 ? 20.8 : TEMPLE_DATUMS.beamBottom - 0.2
);

export const getTempleColumnShaft = (center, pillarTier) => {
  const top = getTempleShaftTop(pillarTier);
  if (pillarTier >= 3) {
    return `M ${center - 2.2} ${TEMPLE_DATUMS.shaftBottom} C ${center - 2.45} 37 ${center - 1.95} 27.5 ${center - 1.5} ${top} L ${center + 1.5} ${top} C ${center + 1.95} 27.5 ${center + 2.45} 37 ${center + 2.2} ${TEMPLE_DATUMS.shaftBottom} Z`;
  }
  if (pillarTier >= 2) {
    return `M ${center - 2.1} ${TEMPLE_DATUMS.shaftBottom} L ${center - 1.45} ${top} L ${center + 1.45} ${top} L ${center + 2.1} ${TEMPLE_DATUMS.shaftBottom} Z`;
  }
  return `M ${center - 1.9} ${TEMPLE_DATUMS.shaftBottom} L ${center - 1.35} ${top} L ${center + 1.35} ${top} L ${center + 1.9} ${TEMPLE_DATUMS.shaftBottom} Z`;
};

export const getTempleInnerColumnShaft = (center, pillarTier) => {
  const top = getTempleShaftTop(pillarTier);
  return `M ${center - 1.15} ${TEMPLE_DATUMS.shaftBottom} L ${center - 0.9} ${top} L ${center + 0.9} ${top} L ${center + 1.15} ${TEMPLE_DATUMS.shaftBottom} Z`;
};

export const getTempleColumnDetails = center => ({
  echinusPath: `M ${center - 1.7} 20.9 L ${center - 3.1} 19.2 L ${center + 3.1} 19.2 L ${center + 1.7} 20.9 Z`,
  abacus: { x: center - 3.6, y: 17.6, width: 7.2, height: 1.7, rx: 0.25 },
  volutes: [center - 2.6, center + 2.6],
  base: { x: center - 3.2, y: 44.3, width: 6.4, height: 1.9, rx: 0.6 },
});

export const getTemplePedimentPath = roofTier => {
  if (roofTier >= 11) return 'M 5 14.6 L 30 3.6 L 55 14.6 Z';
  if (roofTier >= 9) return 'M 5.5 14.6 L 30 4.2 L 54.5 14.6 Z';
  if (roofTier >= 7) return 'M 6.5 14.6 L 30 5 L 53.5 14.6 Z';
  if (roofTier >= 5) return 'M 7.5 15.4 L 30 5.8 L 52.5 15.4 Z';
  if (roofTier >= 4) return 'M 9 15.4 L 30 6.6 L 51 15.4 Z';
  if (roofTier >= 3) return 'M 10.5 15.4 L 30 7.4 L 49.5 15.4 Z';
  return '';
};

export const getTempleTympanumPath = roofTier => (
  roofTier >= 11 ? 'M 9 13.4 L 30 6.2 L 51 13.4 Z' : 'M 10 13.4 L 30 7 L 50 13.4 Z'
);

export const getTempleRoofBeam = roofTier => {
  const x = roofTier >= 5 ? 6 : roofTier >= 3 ? 7 : roofTier >= 2 ? 8 : 8.8;
  const top = roofTier >= 7 ? 14.6 : roofTier >= 3 ? 15.4 : roofTier >= 2 ? 16 : 16.6;
  const width = (30 - x) * 2;
  return {
    x,
    top,
    width,
    height: TEMPLE_DATUMS.beamBottom - top,
    cornice: roofTier >= 5
      ? { x: x - 1.2, y: top, width: width + 2.4, height: 1.1, rx: 0.3 }
      : null,
  };
};
